import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { RootState } from "model";

export type FarmerProgrammeDashboard = {
  guid: string;
  title: string;
  programmeId?: string;
};

export default class FarmerProgrammeDashboardAPI {
  async getIds(): Promise<Array<string>> {
    const res = await fetch(
      `${
        process.env.REACT_APP_API_ENDPOINT
      }/${"v1"}/getDashboards/farmerDashboardIds`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt") || ""}`,
          "Content-Type": "application/json",
        },
      }
    );

    return (await res.json()) as Array<string>;
  }
}

const farmerProgrammeDashboardsApi = new FarmerProgrammeDashboardAPI();

export const fetchAllFarmerProgrammeDashboards = createAsyncThunk(
  "farmerProgrammeDashboard/fetchIds",
  async () => {
    const fetchedDashboardIds = await farmerProgrammeDashboardsApi.getIds();
    return fetchedDashboardIds;
  }
);

const farmerProgrammeDashboardsAdapter =
  createEntityAdapter<FarmerProgrammeDashboard>({
    selectId: (farmerProgrammeDashboard) => farmerProgrammeDashboard.guid,
  });

export const {
  selectAll: selectAllFarmerProgrammeDashboards,
  selectById: selectFarmerProgrammeDashboardById,
  selectEntities: selectFarmerProgrammeDashboardsEntities,
  selectIds: selectFarmerProgrammeDashboardIds,
} = farmerProgrammeDashboardsAdapter.getSelectors(
  (state: RootState) => state.farmerProgrammeDashboards
);

type Status = "success" | "error" | null;
type LoadingState = "idle" | "pending";

export type farmerProgrammeDashboardsState =
  EntityState<FarmerProgrammeDashboard> & {
    loading: LoadingState;
    error: null;
    status: Status;
  };

const initialFarmerProgrammeDashboardsState: farmerProgrammeDashboardsState =
  farmerProgrammeDashboardsAdapter.getInitialState({
    loading: "idle",
    error: null,
    status: null,
  });

const farmerProgrammeDashboardsSlice = createSlice({
  name: "farmerProgrammeDashboards",
  initialState: initialFarmerProgrammeDashboardsState,
  reducers: {
    resetFarmerProgrammeDashboards: () => initialFarmerProgrammeDashboardsState,
  },
  extraReducers: {
    [fetchAllFarmerProgrammeDashboards.fulfilled.type]: (
      state,
      { payload }
    ) => {
      for (const dashboardMetadata of payload.dashboards) {
        farmerProgrammeDashboardsAdapter.upsertOne(state, {
          guid: dashboardMetadata.guid,
          title: dashboardMetadata.title,
          programmeId: dashboardMetadata.programmeId,
        });
      }
    },
  },
});

const { actions, reducer } = farmerProgrammeDashboardsSlice;

export const { resetFarmerProgrammeDashboards } = actions;
export const farmerProgrammeDashboardsReducer = reducer;
